const subIconTextWrapper = `
<div class="sub_icon_text_wrapper">
  <div class="sub_icon_text_item">
    <!-- first svg -->
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
<path fill="currentColor" d="M7.99935 0.666672C3.94926 0.666672 0.666016 3.94992 0.666016 8C0.666016 12.0501 3.94926 15.3333 7.99935 15.3333C12.0494 15.3333 15.3327 12.0501 15.3327 8C15.3327 3.94992 12.0494 0.666672 7.99935 0.666672ZM11.1374 5.80474C11.3978 5.54439 11.3978 5.12228 11.1374 4.86193C10.8771 4.60158 10.455 4.60158 10.1946 4.86193L4.86128 10.1953C4.60093 10.4556 4.60093 10.8777 4.86128 11.1381C5.12163 11.3984 5.54374 11.3984 5.80409 11.1381L11.1374 5.80474ZM4.99935 6C4.99935 5.44772 5.44706 5 5.99935 5C6.55163 5 6.99935 5.44772 6.99935 6C6.99935 6.55229 6.55163 7 5.99935 7C5.44706 7 4.99935 6.55229 4.99935 6ZM8.99935 10C8.99935 9.44772 9.44706 9 9.99935 9C10.5516 9 10.9993 9.44772 10.9993 10C10.9993 10.5523 10.5516 11 9.99935 11C9.44706 11 8.99935 10.5523 8.99935 10Z" clip-rule="evenodd" fill-rule="evenodd"></path>
</svg>
    <span class="font-bold">20% off every order</span>
  </div>
  <div class="sub_icon_text_item">
    <!-- second svg -->
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
<path fill="currentColor" d="M7.22505 2H3.44032C3.0889 1.99999 2.78571 1.99998 2.536 2.02038C2.27244 2.04192 2.01029 2.08946 1.75804 2.21799C1.38171 2.40974 1.07575 2.7157 0.884004 3.09202C0.755475 3.34427 0.707931 3.60642 0.686397 3.86998C0.665995 4.11969 0.666005 4.42286 0.666016 4.77428V10C0.666016 10.8938 1.25226 11.6506 2.06119 11.9069C2.32359 13.104 3.39017 14 4.66602 14C5.90858 14 6.95264 13.1502 7.24867 12H9.3196L9.33268 12.0001H9.68966C9.85146 13.1308 10.8239 14 11.9993 14C13.1888 14 14.1703 13.11 14.3145 11.9597C14.3776 11.9457 14.4431 11.9262 14.5096 11.8986C14.8363 11.7633 15.0959 11.5037 15.2312 11.177C15.2958 11.021 15.3161 10.8705 15.3248 10.7436C15.3327 10.6276 15.3327 10.4911 15.3327 10.3511L15.3327 8.44196L15.3327 8.40793C15.3331 8.28132 15.3335 8.1219 15.2958 7.96501C15.2632 7.82896 15.2093 7.6989 15.1362 7.57961C15.0519 7.44204 14.9389 7.32961 14.8491 7.24032L14.825 7.2163L12.1165 4.50781L12.0925 4.48371C12.0032 4.39394 11.8908 4.28091 11.7532 4.19661C11.6339 4.1235 11.5038 4.06963 11.3678 4.03697C11.2109 3.9993 11.0515 3.99973 10.9249 4.00007L10.8909 4.00013H9.98761C9.98524 3.95526 9.98239 3.91187 9.97897 3.86998C9.95744 3.60642 9.90989 3.34427 9.78136 3.09202C9.58962 2.7157 9.28366 2.40974 8.90733 2.21799C8.65508 2.08946 8.39293 2.04192 8.12937 2.02038C7.87966 1.99998 7.57647 1.99999 7.22505 2ZM13.9991 10.4638C13.9993 10.4263 13.9993 10.3833 13.9993 10.3335V8.44196C13.9993 8.35462 13.9992 8.31103 13.9977 8.27937L13.9976 8.27698L13.996 8.27521C13.9747 8.2518 13.9439 8.22087 13.8822 8.15911L11.1737 5.45062C11.1119 5.38886 11.081 5.35816 11.0576 5.33679L11.0558 5.33518L11.0534 5.33507C11.0218 5.33362 10.9782 5.33346 10.8909 5.33346H9.99935V10.4641C10.4076 9.78653 11.1506 9.33333 11.9993 9.33333C12.848 9.33333 13.5908 9.78638 13.9991 10.4638ZM4.66602 10C3.92964 10 3.33268 10.597 3.33268 11.3333C3.33268 12.0697 3.92964 12.6667 4.66602 12.6667C5.4024 12.6667 5.99935 12.0697 5.99935 11.3333C5.99935 10.597 5.4024 10 4.66602 10ZM10.9993 11.6667C10.9993 11.1144 11.4471 10.6667 11.9993 10.6667C12.5516 10.6667 12.9993 11.1144 12.9993 11.6667C12.9993 12.219 12.5516 12.6667 11.9993 12.6667C11.4471 12.6667 10.9993 12.219 10.9993 11.6667Z" clip-rule="evenodd" fill-rule="evenodd"></path>
</svg>
    <span class="font-bold">Free Delivery</span>
  </div>
  <div class="sub_icon_text_item">
    <!-- third svg -->
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
<path fill="currentColor" d="M5.80474 2.47141C6.06509 2.21107 6.06509 1.78896 5.80474 1.52861C5.54439 1.26826 5.12228 1.26826 4.86193 1.52861L2.19526 4.19527C1.93491 4.45562 1.93491 4.87773 2.19526 5.13808L4.86193 7.80475C5.12228 8.0651 5.54439 8.0651 5.80474 7.80475C6.06509 7.5444 6.06509 7.12229 5.80474 6.86194L4.27614 5.33334L13.3333 5.33334C13.7015 5.33334 14 5.03487 14 4.66668C14 4.29849 13.7015 4.00001 13.3333 4.00001L4.27614 4.00001L5.80474 2.47141Z"></path>
<path fill="currentColor" d="M11.1381 8.19527C10.8777 7.93492 10.4556 7.93492 10.1953 8.19527C9.93491 8.45562 9.93491 8.87773 10.1953 9.13808L11.7239 10.6667H2.66667C2.29848 10.6667 2 10.9652 2 11.3333C2 11.7015 2.29848 12 2.66667 12H11.7239L10.1953 13.5286C9.93491 13.789 9.93491 14.2111 10.1953 14.4714C10.4556 14.7318 10.8777 14.7318 11.1381 14.4714L13.8047 11.8047C14.0651 11.5444 14.0651 11.1223 13.8047 10.8619L11.1381 8.19527Z"></path>
</svg>
    <span class="font-bold">Skip, pause, or swap anytime</span>
  </div>
</div>
`;

// Inject the subscription icon-text wrapper once the Loop widget header is present.
// Uses a MutationObserver that disconnects as soon as it succeeds, with a hard
// 15s stop, instead of a setInterval that runs forever and churns the main thread.
const tryInject = () => {
  if (document.querySelector('.sub_icon_text_wrapper')) return true;
  const target = document.querySelector('div[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-header');
  if (target) { target.insertAdjacentHTML('afterend', subIconTextWrapper); return true; }
  return false;
};
document.addEventListener('DOMContentLoaded', () => {
  if (tryInject()) return;
  const obs = new MutationObserver(() => { if (tryInject()) obs.disconnect(); });
  obs.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => obs.disconnect(), 15000); // hard stop
});

document.addEventListener('DOMContentLoaded', () => {
  const atc_buttons = document.querySelectorAll('.ugc_add_btn');

  atc_buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const variant_id = parseInt(btn.getAttribute('variant-id'));

      btn.classList.add('loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variant_id,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Added to cart:', data);
        
        // Refresh mini cart (Shopify 2.0)
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.refresh === 'function') {
          cartDrawer.refresh(true);
        }

        btn.classList.remove('loading');
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        btn.classList.remove('loading');
      });
    });
  });
});

$(document).ready(function () {

    $('.card_prd_wrapper').on('touchstart', function () {
     $(this).find('.card__media .media img+img').addClass('hover-effect');
    });
  
    $('.card_prd_wrapper').on('touchend touchcancel', function () {
       $(this).find('.card__media .media img+img').removeClass('hover-effect');
    });
    
    
  
  $('.faq-question').on('click', function () {
    var answer = $(this).next('.faq-answer');
    var icon = $(this).find('.toggle-icon');

    if (answer.is(':visible')) {
      answer.slideUp();
      icon.html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z"></path>');
    } else {
      // Close all others
      $('.faq-answer').slideUp();
      $('.toggle-icon').html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z"></path>');
      // Open this one
      answer.slideDown();
      icon.html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M5 11V13H19V11H5Z"></path></svg>');
    }
  });

  
  $('.faq-item:first-child .faq-answer').show();
  $('.faq-item:first-child .toggle-icon').html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M5 11V13H19V11H5Z"></path></svg>');
});
